import { AgentData } from "@/models/AgentData";
import { LoginModel } from "@/models/LoginModel";
import { BaseService } from "./BaseService";

export class AccountService extends BaseService {
  async login(loginModel: LoginModel): Promise<AgentData | null> {
    try {
      const results = await this.client.post<AgentData>("/api/Account/Login", {
        email: loginModel.email,
        otp: loginModel.otp,
      });
      return results.data;
    } catch {
      return null;
    }
  }

  async getLoggedInUser(): Promise<AgentData | null> {
    try {
      const results = await this.client.get<AgentData>("/api/Account");
      return results.data;
    } catch {
      return null;
    }
  }

  async logoff(): Promise<void> {
    await this.client.get("/api/Account/LogOff");
  }

  async sendOtp(email: string): Promise<boolean> {
    try {
      await this.client.post("/api/Account/sendOtp", {
        email: email,
      });
      return true;
    } catch {
      return false;
    }
  }
}
